define("shared/utils/time-helpers/create-and-format-moment-in-tz", ["exports", "@ember/array", "later/utils/time-helpers/create-moment-in-tz"], function (_exports, _array, _createMomentInTz2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/array",0,"later/utils/time-helpers/create-moment-in-tz"eaimeta@70e063a35619d71f

  /**
   * @module Utils
   */

  /**
   * @class createMomentAndFormatInTz
   * @extends Utils
   */

  /**
   * Takes the unix timestamp(s) and returns the
   * moment object in the local timezone in the format provided.
   *
   * @method createAndFormatMomentInTz
   * @param {String|Array} date unix timestamp or array of unix timestamps
   * @param {String} timezone the timezone name
   * @param {String} format format to dispaly with moment
   *
   * @returns {Moment} Moment object in local timezone
   */
  const createAndFormatMomentInTz = (date, timezone, format) => {
    var _createMomentInTz;

    const isDateRange = (0, _array.isArray)(date);

    if (isDateRange) {
      return date.map(date => (0, _createMomentInTz2.default)(Number(date), timezone).format(format));
    }

    return (_createMomentInTz = (0, _createMomentInTz2.default)(Number(date), timezone)) === null || _createMomentInTz === void 0 ? void 0 : _createMomentInTz.format(format);
  };

  var _default = createAndFormatMomentInTz;
  _exports.default = _default;
});